import { isInvoiceSelected, updateInvoiceSelection } from '../../utils/functions/invoiceSelection';
import React, { useEffect, useState } from 'react';
import { invoicePaymentAmount, invoiceTxnAmount } from '../../utils/functions/invoiceAmounts';
import TextField from '@mui/material/TextField';
import PersonIcon from '@mui/icons-material/Person';
import InputAdornment from '@mui/material/InputAdornment';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import addCommas from '../../utils/functions/commas';
import { adjustedTotal, baseFromAdjustedTotal, netGrandTotal, baseFromNetGrandTotal, toSatang } from '../../utils/functions/roundingAmount';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Input from '@mui/material/Input';
import _ from 'lodash';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles'; // 1. ต้อง import 'styled'
import dayjs from 'dayjs';
import axios from '../../utils/functions/api';


// Temporarily pause rounding controls and arithmetic together.
const ROUNDING_ADJUSTMENT_ENABLED = false;

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fff', // หรือ theme.palette.action.hover ถ้าต้องการ
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },

  // [ปรับปรุง] ย้าย :hover มาไว้ที่นี่
  '&:hover': {
   
    boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer', // เพิ่ม cursor เพื่อให้รู้ว่า hover ได้
  },

    // [ปรับปรุง] เพิ่ม style สำหรับ 'selected'
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: '#d0f8ce', // สีเขียวที่คุณใช้
  },


  transition: 'transform 0.15s ',
}));


function SearchApprovedAndTableData({
  total,
  setInvoicesDataApproved,
  matchButtonApi,
  dataApproved,
  page,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  setDataApproved,
  handleOnClick,
  setSearchUpload,
  searchUpload,
  setSearchText,
  searchText,
  isFetching,
  clearSelectedItems,
  setClearSelectedItems,
  selectedItems,
  setSelectedItems,
 calculateTotalAmount,
 t,
 approvedSortBy,
 approvedSortOrder,
 onApprovedSort,
 onDraftSaved,
}) {
 
  const [openDialogEdit, setOpenDialogEdit] = useState(false);
  const [selectRowEdit, setSelectRowEdit] = useState('');

  const [totalAmount, setTotalAmount] = useState('');
  const [invGrand, setInvGrand] = useState('');
  const [whtRate, setWhtRate] = useState('');
  const [whtAmount, setWhtAmount] = useState('');
  const [fee, setFee] = useState('');
  const [roundingAmount, setRoundingAmount] = useState('');
  const [roundingDirection, setRoundingDirection] = useState('');
  const [emailReceipt, setEmailReceipt] = useState(false);
  const [isSavingDraft, setIsSavingDraft] = useState(false);

  const toSafeNumber = (value, fallback = 0) => {
    const parsed = Number(String(value ?? '').replace(/,/g, ''));
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  useEffect(() => {
    if (clearSelectedItems) {
      setSelectedItems([]);
      setClearSelectedItems(false);
    }
  }, [clearSelectedItems, setClearSelectedItems]);

  const handleInputChange = (e, field) => {
    if (field === 'totalAmount') {
      setTotalAmount(e.target.value);
    } else if (field === 'invGrand') {
      setInvGrand(baseFromNetGrandTotal(e.target.value, roundingAmount, ROUNDING_ADJUSTMENT_ENABLED ? roundingDirection : '', fee));
    } else if (field === 'whtRate') {
      setWhtRate(e.target.value);
    } else if (field === 'whtAmount') {
      setWhtAmount(e.target.value);
    } else if (field === 'fee') {
      if (/^\d*(\.\d{0,2})?$/.test(e.target.value)) {
        setFee(e.target.value);
      }
    } else if (field === 'roundingAmount') {
      if (ROUNDING_ADJUSTMENT_ENABLED && /^\d*(\.\d{0,2})?$/.test(e.target.value)) {
        setRoundingAmount(e.target.value);
      }
    }
  };

  const handleChangeDialog = (row) => {
    setSelectRowEdit(row);
    setOpenDialogEdit(true);
    setEmailReceipt(row.isSendMail);
    setTotalAmount(row.total_amount ?? '');
    const direction = ['up', 'down'].includes(row.add_gl_diff) ? row.add_gl_diff : '';
    const amount = (Math.abs(toSatang(row.price_gl_diff)) / 100).toFixed(2);
    const hasSavedAdjustment = ['up', 'down'].includes(row.add_gl_diff);
    setInvGrand(ROUNDING_ADJUSTMENT_ENABLED && hasSavedAdjustment
      ? baseFromAdjustedTotal(row.total_pay_amount, amount, direction)
      : invoicePaymentAmount(row));
    setRoundingDirection(direction);
    setWhtRate(row.max_wht_rate ?? '');
    setWhtAmount(row.total_wht_amount ?? '');
    setFee(row.fee ?? 0);
    setRoundingAmount(amount);
  };

  const handleClose = async (agree = false) => {
    if (!agree) {
      setOpenDialogEdit(false);
      return;
    }

    const updatedRow = handleSave();
    if (!updatedRow) {
      setOpenDialogEdit(false);
      return;
    }

    setIsSavingDraft(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL_admin}/matchstatement/save-invoice-draft`,
        {
          invoice: updatedRow,
        },
      );

      if (typeof onDraftSaved === 'function') {
        await onDraftSaved(updatedRow);
      }

      setOpenDialogEdit(false);
    } catch (error) {
      console.error('Error saving invoice draft:', error);
    } finally {
      setIsSavingDraft(false);
    }
  };

  const handleChangeSearchText = (event) => {
    setSearchText(event.target.value);
  };
  const handleChangeSearchUpload = (event) => {
    setSearchUpload(event.target.value);
  };

  const handleSave = () => {
    let updatedRowRef = null;

    const updatedData = dataApproved.map((row) => {
      if (
        row.invoice_no === selectRowEdit.invoice_no &&
        row.transaction_id === selectRowEdit.transaction_id
      ) {
        updatedRowRef = {
          ...row,
          total_amount: toSafeNumber(totalAmount, row.total_amount),
          total_pay_amount: Number(adjustedTotal(invGrand, roundingAmount, ROUNDING_ADJUSTMENT_ENABLED ? roundingDirection : '')),
          max_wht_rate: toSafeNumber(whtRate, row.max_wht_rate),
          total_wht_amount: toSafeNumber(whtAmount, row.total_wht_amount),
          fee: toSafeNumber(fee, row.fee),
          price_gl_diff: ROUNDING_ADJUSTMENT_ENABLED
            ? (roundingDirection ? Math.abs(toSatang(roundingAmount)) / 100 : 0)
            : row.price_gl_diff,
          add_gl_diff: ROUNDING_ADJUSTMENT_ENABLED ? roundingDirection : row.add_gl_diff,
          isSendMail: emailReceipt,
        };

        return updatedRowRef;
      }

      return row;
    });

    setDataApproved(updatedData);

    if (updatedRowRef) {
      setSelectRowEdit(updatedRowRef);
      setSelectedItems(
        selectedItems.map((item) => {
          if (
            item.invoice_no === updatedRowRef.invoice_no &&
            item.transaction_id === updatedRowRef.transaction_id
          ) {
            return updatedRowRef;
          }

          return item;
        }),
      );
    }

    return updatedRowRef;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // รีเซ็ตหน้าเมื่อจำนวนแถวต่อหน้าถูกเปลี่ยน
  };

  const handleCheckboxChange = (event, row) => {
    const checked = event.target.checked;
    setSelectedItems((previous) => updateInvoiceSelection(previous, [row], checked));
  };

  const handleSelectAllRows = (event) => {
    const checked = event.target.checked;
    setSelectedItems((previous) => updateInvoiceSelection(previous, dataApproved || [], checked));
  };

  const isSelected = (row) => isInvoiceSelected(selectedItems, row);
  const visibleSelectedCount = (dataApproved || []).filter(isSelected).length;

  useEffect(() => {
    if (selectedItems) {
      setInvoicesDataApproved(selectedItems);
    }
  }, [selectedItems, setInvoicesDataApproved]);

  const customCellHeader = {
    whiteSpace: 'nowrap',
    backgroundColor: '#4caf50',
    color: 'white',
    padding: '12px',
    fontWeight: 'bold',
    fontSize: '13px',
    position: 'sticky',
    top: 0,
    zIndex: 2,
  };

  const customCellData = {
    whiteSpace: 'nowrap',
    fontSize: '12px',
    padding: '10px',
    borderBottom: '1px solid #e0e0e0',
  };

  const sortLabelSx = {
    color: '#fff !important',
    '& .MuiTableSortLabel-icon': {
      color: '#fff !important',
    },
  };

  const approvedColumns = [
    {
      id: 'invoice_no',
      label: t('app.invoiceNo'),
      align: 'left',
      sortable: true,
      withCheckbox: true,
    },
    { id: 'upload_ref', label: t('app.uploadRef'), sortable: true },
    { id: 'CustomerCode', label: t('navbar.custNo'), sortable: true },
    { id: 'CustomerName', label: t('app.customerName'), sortable: true },
    { id: 'total_amount', label: t('app.invoiceAmount'), sortable: true },
    { id: 'txn_amount', label: t('app.txnAmount'), sortable: true },
    { id: 'bank_fullname', label: t('app.bookbankNo'), sortable: true },
    { id: 'transfer_date', label: t('app.paymentDate'), sortable: true },
    { id: 'edit', label: t('app.edit'), sortable: false },
  ];

  const handleSortRequested = (columnId) => {
    if (onApprovedSort) onApprovedSort(columnId);
  };

  return (
    <div className="">
      <div className="border-2 border-gray-300 xl:h-[300px] p-2">
        <div className=" ">
          {' '}
      {t('app.customerNameTaxID')}
          <div className="">
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonIcon />
                  </InputAdornment>
                ),
              }}
              className='"app-search-input'
              type="text"
              placeholder="Search Customer Name / Tax ID"
              id="outlined-basic"
              size="small"
              sx={{ width: '100%', backgroundColor: '#FFFFFF' }}
              value={searchText}
              onChange={handleChangeSearchText}
            />
          </div>
        </div>
        <div className="mt-5">
          {' '}
        {t('app.uploadReference')}
          <div className="">
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FileUploadIcon />
                  </InputAdornment>
                ),
              }}
              placeholder={t('app.searchUploadReference')}
              id="outlined-basic"
              size="small"
              sx={{ width: '100%', backgroundColor: '#FFFFFF' }}
              value={searchUpload}
              onChange={handleChangeSearchUpload}
            />
          </div>
        </div>
        {/* <div className="flex justify-end mt-14 ">
          <Button onClick={handleOnClick} variant="outlined">
            Search Data
          </Button>
        </div> */}
      </div>

      <div className="mt-5 border-2  ">
        <div>
          <TableContainer
            sx={{
              maxHeight: 330,
              overflow: 'auto',
              backgroundColor: 'white',
              position: 'relative',
            }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  {approvedColumns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align || 'center'}
                      sx={customCellHeader}
                    >
                      {column.withCheckbox ? (
                        <Box display="flex" alignItems="center">
                          <Checkbox
                            color="default"
                            checked={Boolean(dataApproved?.length) && visibleSelectedCount === dataApproved.length}
                            indeterminate={visibleSelectedCount > 0 && visibleSelectedCount < dataApproved.length}
                            onChange={(e) => handleSelectAllRows(e)}
                            sx={{ padding: 0, marginRight: 1 }}
                          />
                          <TableSortLabel
                            active={approvedSortBy === column.id}
                            direction={
                              approvedSortBy === column.id
                                ? approvedSortOrder
                                : 'asc'
                            }
                            onClick={() => handleSortRequested(column.id)}
                            sx={sortLabelSx}
                          >
                            {column.label}
                          </TableSortLabel>
                        </Box>
                      ) : column.sortable ? (
                        <TableSortLabel
                          active={approvedSortBy === column.id}
                          direction={
                            approvedSortBy === column.id ? approvedSortOrder : 'asc'
                          }
                          onClick={() => handleSortRequested(column.id)}
                          sx={sortLabelSx}
                        >
                          {column.label}
                        </TableSortLabel>
                      ) : (
                        column.label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {isFetching ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                ) : dataApproved?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <div className="text-gray-500">ไม่มีข้อมูล</div>
                    </TableCell>
                  </TableRow>
                ) : (
                  dataApproved?.map((row, index) => (
                    <StyledTableRow
                      key={index}
                      
                    >
                      <TableCell align="left" sx={customCellData}>
                        <Box display="flex" alignItems="center">
                          <Checkbox
                            onChange={(event) =>
                              handleCheckboxChange(event, row)
                            }
                            checked={isSelected(row)}
                            sx={{ padding: 0, marginRight: 1 }}
                          />
                          <span className="text-green-600 font-semibold">
                            {row.invoice_no}
                          </span>
                        </Box>
                      </TableCell>

                      <TableCell align="center" sx={customCellData}>
                        {row.upload_ref}
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        {row.CustomerCode}
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        {row.CustomerName}
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        {addCommas(row.total_amount)}
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        {addCommas(invoiceTxnAmount(row))}
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        {row.bank_fullname} {row.bank_account}
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        {dayjs(row.transfer_date).format('YYYY-MM-DD • HH:mm:ss')}
                      </TableCell>
                      <TableCell align="center" sx={customCellData}>
                        <Button
                          onClick={() => handleChangeDialog(row)}
                          sx={{ minWidth: 0 }}
                        >
                          <EditIcon fontSize="small" />
                        </Button>
                      </TableCell>
                    </StyledTableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={total} // จำนวนข้อมูลที่ฟีลเตอร์แล้ว
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>

      {openDialogEdit && (
        <EditDialog
          {...{
            t,
            openDialogEdit,
            selectRowEdit,
            emailReceipt,
            totalAmount,
            invGrand: netGrandTotal(invGrand, roundingAmount, ROUNDING_ADJUSTMENT_ENABLED ? roundingDirection : '', fee),
            whtRate,
            whtAmount,
            fee,
            roundingAmount,
            roundingDirection,
            setRoundingDirection,
            setEmailReceipt,
            setSelectRowEdit,
            handleClose,
            handleInputChange,
            isSavingDraft,
          }}
        />
      )}

      <div className="hidden xl:flex justify-between mt-5">
        <div className="font-bold">
          {t('app.totalSelectedAmount')} : {addCommas(calculateTotalAmount())} THB
        </div>
        <div>
          <Button
            variant="contained"
            sx={{ color: 'white' }}
            onClick={matchButtonApi}
          >
            {t('app.matching')}
          </Button>
        </div>
      </div>
    </div>
  );
}

function EditDialog(props) {
  const [grandTotalInput, setGrandTotalInput] = useState(null);
  const {
    t,
    openDialogEdit,
    selectRowEdit,
    emailReceipt,
    totalAmount,
    invGrand,
    whtRate,
    whtAmount,
    fee,
    roundingAmount,
    roundingDirection,
    setRoundingDirection,
    setEmailReceipt,
    handleClose,
    handleInputChange,
    isSavingDraft,
  } = props;

  return (
    <>
      <Dialog
        open={openDialogEdit}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title ">
          {t('app.invoiceNo')} {selectRowEdit.invoice_no}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description mt-10">
            {selectRowEdit && (
              <div>
                <FormControlLabel
                  className="pl-2 pb-2"
                  label={`${t('app.emailReceipt')} ${
                    selectRowEdit.mail ? selectRowEdit.mail : t('app.noEmail')
                  }`}
                  control={
                    <Checkbox
                      style={{ paddingLeft: 0 }}
                      disableRipple
                      disabled={!selectRowEdit.mail}
                      checked={emailReceipt}
                      onChange={(e) => setEmailReceipt(e.target.checked)}
                    />
                  }
                />
                <Grid container rowSpacing={2} columnSpacing={3}>
                  <Grid item xs={12} md={6}>
                    <div className="flex flex-col">
                      {t('app.whtRatePercent')}
                      <Input
                        value={whtRate}
                        onChange={(e) => handleInputChange(e, 'whtRate')}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="flex flex-col">
                      {t('app.whtAmountThb')}
                      <Input
                        value={whtAmount}
                        onChange={(e) => handleInputChange(e, 'whtAmount')}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="flex flex-col">
                       {t('app.feeThb')}
                      <Input
                        value={fee}
                        onChange={(e) => handleInputChange(e, 'fee')}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="flex flex-col">
                       {t('app.roundingAmount')}
                      <Input
                        value={roundingAmount}
                        disabled={!ROUNDING_ADJUSTMENT_ENABLED}
                        onChange={(e) => handleInputChange(e, 'roundingAmount')}
                        inputProps={{ 'aria-label': t('app.roundingAmount'), inputMode: 'decimal' }}
                        onBlur={(e) => handleInputChange({ target: { value: (Math.abs(toSatang(e.target.value)) / 100).toFixed(2) } }, 'roundingAmount')}
                        endAdornment={ROUNDING_ADJUSTMENT_ENABLED && (
                          <InputAdornment position="end" sx={{ maxHeight: 'none' }}>
                            <RadioGroup
                              row
                              aria-label="ยอดเกินหรือขาด"
                              name="rounding-direction"
                              value={roundingDirection}
                              onChange={(e) => setRoundingDirection(e.target.value)}
                              sx={{ flexWrap: 'nowrap', borderLeft: 1, borderColor: 'divider', pl: 1 }}
                            >
                              <FormControlLabel
                                value="up"
                                control={<Radio size="small" color="success" disabled={isSavingDraft} />}
                                label="เกิน"
                                sx={{ m: 0, whiteSpace: 'nowrap' }}
                              />
                              <FormControlLabel
                                value="down"
                                control={<Radio size="small" color="success" disabled={isSavingDraft} />}
                                label="ขาด"
                                sx={{ m: 0, whiteSpace: 'nowrap' }}
                              />
                            </RadioGroup>
                          </InputAdornment>
                        )}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="flex flex-col">
                         {t('app.invoiceAmountExcludeVat')}
                      <Input
                        value={totalAmount}
                        onChange={(e) => handleInputChange(e, 'totalAmount')}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="flex flex-col">
                       {t('app.invoiceGrandTotal')}
                      <Input
                        value={grandTotalInput ?? invGrand}
                        inputProps={{ inputMode: 'decimal' }}
                        onChange={(e) => {
                          if (/^\d*(\.\d{0,2})?$/.test(e.target.value)) {
                            setGrandTotalInput(e.target.value);
                            handleInputChange(e, 'invGrand');
                          }
                        }}
                        onBlur={() => setGrandTotalInput(null)}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)} disabled={isSavingDraft}>  {t('app.cancel')}</Button>
          <Button onClick={() => handleClose(true)} disabled={isSavingDraft}>{t('app.submit')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SearchApprovedAndTableData;
